/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */

<template>
  <LayoutPrincipal>
    <div class="welcome-container">

      <ModalGestionSuscripcion 
        v-if="mostrarModalAviso" 
        @continuar="continuarConSuscripcion"
        @cancelar="manejarCancelacion"
      />
      <ModalExito
        v-if="showModalExito"
        :mostrarExito="showModalExito"
        :mensajeExito="mensajeBackend"
        @cancelar="showModalExito = false"
      />
      <ModalError
        v-if="showModalError"
        :mostrarExito="showModalError"
        :mensajeExito="mensajeBackend"
        @cancelar="cerrarError"
      />

      <div class="dashboard-card hero-card">
        <div class="fechaYsaludo">
          <span class="badge-greeting">¡Hola de nuevo!</span>
          <div class="date-pill">
            <i class="fa-regular fa-calendar"></i> {{ fechaActual }}
          </div>
        </div>
        <div class="hero-content">
          <div class="hero-text-block">
            <h1 class="hero-name">Bienvenido, {{ cargarUsuario }}</h1>
            <p class="hero-description">
              Nos alegra tenerte aquí,
              ¿Listo para llevar tus proyectos al siguiente nivel hoy?.
            </p>
            <Button id="btn-crear-cotizacion" class="btn-hero" @click="irACotizador">
              Crear cotización
            </Button>
          </div>
        </div>
      </div>

      <div class="bottom-grid">
        <div class="dashboard-card resources-section">
          <div class="card-header">
            <h3 class="card-title">Centro de Recursos</h3>
            <p class="card-subtitle">Documentación importante para ti.</p>
          </div>

          <div class="resources-list">
            <div class="resource-item" @click="iniciarTutorial">
              <div class="icon-sq blue">
                <i class="fa-solid fa-wand-magic-sparkles"></i>
              </div>
              <div class="res-info">
                <h4>Tour de la Plataforma</h4>
                <span>Te enseñamos a usarla</span>
              </div>
              <div class="res-action">
                <i class="fa-solid fa-play"></i>
              </div>
            </div>

            <div class="resource-item">
              <div class="icon-sq red">
                <i class="fa-solid fa-file-pdf"></i>
              </div>
              <div class="res-info">
                <h4>Manual de Usuario 2024</h4>
                <span>PDF • 2.4 MB</span>
              </div>
              <div class="res-action">
                <i class="fa-solid fa-download"></i>
              </div>
            </div>

            <div class="resource-item">
              <div class="icon-sq orange">
                <i class="fa-solid fa-shield-halved"></i>
              </div>
              <div class="res-info">
                <h4>Términos y Condiciones</h4>
                <span>Lectura obligatoria</span>
              </div>
              <div class="res-action">
                <i class="fa-solid fa-arrow-up-right-from-square"></i>
              </div>
            </div>
          </div>
        </div>

        <div class="dashboard-card dark-media-card">
          <div class="video-container">
            <video class="bg-video" autoplay muted loop playsinline>
              <source src="@/assets/videos/HeroVideo.mp4" type="video/mp4">
              Tu navegador no soporta el elemento de video.
            </video>

            <div class="video-overlay">
              <img src="../assets/images/ania-logo.png" alt="Logo" class="overlay-logo" />
            </div>
          </div>
        </div>
      </div>
      <LoadScreen v-if="cargando" />
    </div>
  </LayoutPrincipal>
</template>

<script>
import LayoutPrincipal from "../layouts/layoutPrincipal.vue";
import Button from '@/components/Forms/Button.vue';
import confetti from 'canvas-confetti';
import ModalGestionSuscripcion from "@/components/Modales/ModalGestionSuscripcion.vue"; 
import pagosService from '@/services/pagosService';
import ModalExito from "@/components/Modales/ModalExito.vue";
import ModalError from "@/components/Modales/ModalError.vue";
import LoadScreen from "@/components/Forms/LoadScreen.vue"; 
import { driver } from "driver.js";
import "driver.js/dist/driver.css";

export default {
  components: { 
    LayoutPrincipal, 
    Button,
    ModalGestionSuscripcion,
    ModalExito,
    ModalError,
    LoadScreen
  },
  props: {
    nombreUsuario: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      mostrarModalAviso: false,
      cargando:false,
      showModalExito: false,   
      showModalError: false,   
      mensajeBackend: ''
    };
  },
  computed: {
    fechaActual() {
      const opciones = { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' };
      const fecha = new Date().toLocaleDateString('es-ES', opciones);
      return fecha.charAt(0).toUpperCase() + fecha.slice(1);
    },
    cargarUsuario() {
      const userData = JSON.parse(localStorage.getItem('userData'));
      return userData ? userData.nombre : 'Usuario';
    }
  },
  async mounted() {
    if (!sessionStorage.getItem('aviso_renovacion_visto')) {
    await this.verificarProximidadRenovacion();
  }
  },
  methods: {
    async verificarProximidadRenovacion() {
      try {
        const response = await pagosService.verificarEstatusSuscripcion();
        const info = response.data;

        console.log("Datos reales:", info);

        if (info && info.status === 'active' && info.fecha_fin_periodo) {
          
          const fechaVencimiento = new Date(info.fecha_fin_periodo);
          const hoy = new Date();
          
          fechaVencimiento.setHours(0, 0, 0, 0);
          hoy.setHours(0, 0, 0, 0);

          const diferenciaMilisegundos = fechaVencimiento.getTime() - hoy.getTime();
          const diasRestantes = Math.floor(diferenciaMilisegundos / (1000 * 60 * 60 * 24));

          console.log("Días calculados:", diasRestantes);

          if (diasRestantes <= 5 && diasRestantes >= 0) {
            this.mostrarModalAviso = true;
          }
        }
      } catch (error) {
        console.error("Error al verificar renovación:", error);
      }
    },
    irACotizador() {
      this.$router.push('/Cotizaciones');
    },
    continuarConSuscripcion() {
      sessionStorage.setItem('aviso_renovacion_visto', 'true');
      this.mostrarModalAviso = false;
    },
    async manejarCancelacion() {
      this.cargando = true;
      
      try {
        const response = await pagosService.cancelarSuscripcion();
      
        if(response.data){
          this.mensajeBackend = "Cancelación realizada. Tu suscripción seguirá activa y se restringirá el acceso una vez finalizado tu periodo actual.";
          this.showModalExito = true;
          setTimeout(() => {
            this.showModalExito = false;
          }, 3000);
        }
      } catch (error) {
        console.error("Error al cancelar:", error);
        this.mensajeBackend = "No se pudo procesar la cancelacion. Inteta mas tarde";
        this.showModalError = true;
        setTimeout(() => {
          this.cerrarError();
        }, 2500);
      } finally {
        this.cargando = false;
      }
    },
    cerrarError() {
      this.showModalError = false;
      this.mensajeBackend = '';
    },

    lanzarConfetti() {
      const duracion = 3 * 1000;
      const animacionEnd = Date.now() + duracion;

      const interval = setInterval(function () {
        const timeLeft = animacionEnd - Date.now();
        if (timeLeft <= 0) return clearInterval(interval);

        confetti({
          particleCount: 40,
          startVelocity: 30,
          spread: 360,
          origin: {
            x: Math.random(),
            y: Math.random() - 0.2
          },
          zIndex: 9999
        });
      }, 200);
    },

    iniciarTutorial() {
      const driverObj = driver({
        showProgress: true,
        animate: true,
        nextBtnText: 'Siguiente',
        prevBtnText: 'Atrás',
        doneBtnText: '¡Listo, a trabajar!',
        popoverClass: 'driverjs-theme-custom',

        onDestroyed: () => {
          if (this.$store.state.collapsedMenu) {
            this.$store.commit('toggleMenu');
          }
          this.lanzarConfetti();

          const btn = document.getElementById('btn-crear-cotizacion');
          if (btn) {
            btn.classList.add('pulse-effect');
            setTimeout(() => {
              btn.classList.remove('pulse-effect');
            }, 10000);
          }
        },

        onHighlightStarted: (_, step) => {
          const necesitaMenuAbierto = ['#tour-cotizaciones', '#tour-clientes'].includes(step.element);

          if (necesitaMenuAbierto && !this.$store.state.collapsedMenu) {
            this.$store.commit('toggleMenu');
            return new Promise((resolve) => {
              setTimeout(() => {
                window.dispatchEvent(new Event('resize'));
                driverObj.refresh();
                resolve();
              }, 450);
            });
          }
        },

        steps: [
          {
            element: '#tour-sidebar',
            popover: {
              title: 'Panel de Navegación',
              description: '¡Bienvenido! Este es el punto de partida para moverte por la app de forma sencilla.',
              side: 'right',
            }
          },
          {
            element: '#tour-toggle-btn',
            popover: {
              title: '¿Necesitas más espacio?',
              description: 'Puedes expandir el panel con este botón y ver claramente cada sección.',
              side: 'right'
            },
            onNextClick: () => {
              if (!this.$store.state.collapsedMenu) {
                this.$store.commit('toggleMenu');
                setTimeout(() => {
                  driverObj.refresh();
                  driverObj.moveNext();
                }, 400);
              } else {
                driverObj.moveNext();
              }
            }
          },
          {
            element: '#tour-cotizaciones',
            popover: {
              title: 'Módulo de Cotizaciones',
              description: 'Nuestra herramienta estrella, aquí creas presupuestos profesionales.',
              side: 'right'
            }
          },
          {
            element: '#tour-clientes',
            popover: {
              title: 'Gestión de Clientes',
              description: 'Mantén un control total de tu cartera y el historial completo.',
              side: 'right'
            },
            onNextClick: () => {
              if (this.$store.state.collapsedMenu) {
                this.$store.commit('toggleMenu');
              }
              setTimeout(() => {
                driverObj.refresh();
                driverObj.moveNext();
              }, 400);
            }
          },
          {
            element: '#tour-profile',
            popover: {
              title: 'Tu Perfil y Cuenta',
              description: 'Administra tu información personal y consulta el estado de tu membresía.',
              side: 'left'
            }
          },
          {
            element: '.resources-section',
            popover: {
              title: 'Centro de Capacitación',
              description: '¿Tienes dudas? Aquí encontrarás guías y manuales.',
              side: 'top'
            }
          },
          {
            popover: {
              title: '¡Todo listo para comenzar!',
              description: 'Gracias por formar parte de nuestra comunidad.',
              side: 'center',
              align: 'center'
            }
          }
        ]
      });

      driverObj.drive();
    }
  }
};
</script>

<style scoped>
.welcome-container {
  --w-primary: #29b9f6;
  --w-dark: #1e293b;
  --w-bg: #ffffff;
  --w-border: #e2e8f0;
  --w-text: #334155;
  --w-muted: #64748b;

  font-family: 'Inter', sans-serif;
  color: var(--w-text);
  width: 100%;
  box-sizing: border-box;
  padding-top: 10px;
}

.welcome-container * {
  box-sizing: border-box;
}

.hero-card {
  background-color: var(--w-bg);
  border-radius: 16px;
  padding: 40px;
  position: relative;
  overflow: hidden;
  margin-bottom: 30px;
  box-shadow: 0px 3px 6px #00000029;
}

.hero-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 2;
}

.hero-text-block {
  max-width: 600px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.date-pill {
  background-color: #f8fafc;
  color: var(--w-muted);
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 0.8rem;
  font-weight: 500;
  border: 1px solid var(--w-border);
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 15px;
}

.badge-greeting {
  background-color: #f8fafc;
  color: var(--w-muted);
  border-radius: 8px;
  border: 1px solid var(--w-border);
  font-size: 0.8rem;
  font-weight: 700;
  padding: 6px 14px;
  display: inline-block;
  margin-bottom: 15px;
}

.hero-name {
  font-size: 2.2rem;
  font-weight: 800;
  color: #0f172a;
  margin: 0 0 15px 0;
}

.hero-description {
  font-size: 1rem;
  color: var(--w-muted);
  line-height: 1.6;
  margin-bottom: 25px;
}

.btn-hero {
  background-color: #2a428c;
  color: white;
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;
  position: relative;
}

.btn-hero:hover {
  background-color: #267296;
}

.pulse-effect {
  animation: pulse-animation 1.5s infinite;
}

@keyframes pulse-animation {
  0% { box-shadow: 0 0 0 0px rgba(152, 77, 33, 0.7); }
  70% { box-shadow: 0 0 0 15px rgba(152, 77, 33, 0); }
  100% { box-shadow: 0 0 0 0px rgba(152, 77, 33, 0); }
}

.bottom-grid {
  display: grid;
  grid-template-columns: 1.6fr 1fr;
  gap: 30px;
  align-items: stretch;
}

.dashboard-card {
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0px 3px 6px #00000029;
}

.resources-section {
  background: white;
  padding: 30px;
  display: flex;
  flex-direction: column;
}

.card-header { margin-bottom: 25px; }
.card-title { font-size: 1.1rem; font-weight: 700; color: #0f172a; margin: 0 0 5px 0; }
.card-subtitle { margin: 0; font-size: 0.9rem; color: var(--w-muted); }

.resources-list { display: flex; flex-direction: column; gap: 15px; }
.resource-item {
  display: flex;
  align-items: center;
  padding: 15px;
  border: 1px solid var(--w-border);
  border-radius: 12px;
  transition: all 0.2s ease;
  cursor: pointer;
}

.resource-item:hover {
  border-color: var(--w-primary);
  box-shadow: 0 4px 12px rgba(47, 141, 183, 0.08);
  transform: translateY(-2px);
}

.fechaYsaludo { display: flex; justify-content: space-between; }

.icon-sq {
  width: 42px; height: 42px; border-radius: 10px;
  display: flex; align-items: center; justify-content: center;
  font-size: 1.2rem; margin-right: 15px; flex-shrink: 0;
}

.icon-sq.red, .icon-sq.orange, .icon-sq.blue { background: #f8fafc; color: #2a428c; }

.res-info { flex: 1; }
.res-info h4 { margin: 0 0 2px 0; font-size: 0.95rem; font-weight: 600; color: #334155; }
.res-info span { font-size: 0.8rem; color: #94a3b8; }
.res-action { color: #cbd5e1; }

.dark-media-card { padding: 0; display: flex; flex-direction: column; overflow: hidden; min-height: 300px; }
.video-container { position: relative; flex: 1; width: 100%; background: black; overflow: hidden; }
.bg-video { width: 100%; height: 100%; object-fit: cover; display: block; }
.video-overlay {
  position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);
  z-index: 10; background-color: rgba(255, 255, 255, 0.35);
  padding: 20px 30px; border-radius: 16px; box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.2); display: flex; justify-content: center; align-items: center;
}
.overlay-logo { max-width: 300px; height: auto; display: block; }

:deep(.driverjs-theme-custom) {
  background-color: #ffffff; border-radius: 12px; padding: 20px;
  border: 1px solid #e2e8f0; box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}
:deep(.driverjs-theme-custom .driver-popover-title) {
  font-family: 'Inter', sans-serif; font-weight: 800; color: #0f172a; font-size: 1.2rem;
}
:deep(.driverjs-theme-custom .driver-popover-next-btn) {
  background-color: #29b9f6; color: #ffffff; border: none; border-radius: 6px; font-weight: 600;
}

@media (max-width: 950px) {
  .bottom-grid { grid-template-columns: 1fr; padding-bottom: 20px; }
  .hero-content { flex-direction: column; text-align: center; }
  .hero-text-block { align-items: center; }
  .overlay-logo { max-width: 80px; }
  .fechaYsaludo { display: none; }
}
</style>